export function receivingCategoryListByFilter(filter) {
  const query = `{receivingCategoryListByFilter(filter: ${JSON.stringify(
    filter
  ).replace(/"([^(")"]+)":/g, '$1:')}) {id, name, description, active}}`;
  return query;
}

export function saveReceivingCatMutation(values) {
  const mutationQuery = `mutation {
    receivingCategorySave(                              
      receivingCategory: {id: ${values.id ? values.id : 0}
                    , name: "${
                      values.name
                    }"                                            
                    , description: "${
                      values.description ? values.description : ''
                    }"
                    , active: ${values.active}
                    , filterByStatus: false                                        
                    , updaterId: 0
                }),
    {id}
}`;
  return mutationQuery;
}

export function removeReceivingCatMutation(id) {
  const query = `mutation {receivingCategoryRemove(id: ${id})}`;
  return query;
}
